import { isCheckoutOffer, isCheckoutRegular } from "./checkoutType";

/** offerResourceText is optional. If undefined, the regularResourceText is returned **/
function getCorrectResourceText(
  checkoutType,
  regularResourceText,
  offerResourceText
) {
  if (isCheckoutRegular(checkoutType)) {
    return regularResourceText;
  }

  if (isCheckoutOffer(checkoutType)) {
    return offerResourceText || regularResourceText;
  }

  return "";
}

function getTextsMapping(resourceTexts, checkoutType) {
  const r = resourceTexts;

  return {
    ...resourceTexts,
    orderSummaryTitle: getCorrectResourceText(
      checkoutType,
      r.orderSummaryTitle,
      r.orderSummaryTitleOffer
    ),
    moduleScheduleSubTitle: getCorrectResourceText(
      checkoutType,
      r.moduleScheduleSubTitle,
      undefined
    ),
    moduleScheduleText: getCorrectResourceText(
      checkoutType,
      r.moduleScheduleText,
      undefined
    ),
    moduleScheduleErrorMessage: getCorrectResourceText(
      checkoutType,
      r.moduleScheduleErrorMessage,
      undefined
    ),
    personalDetailsText: getCorrectResourceText(
      checkoutType,
      r.personalDetailsText,
      undefined
    ),
    homeAddressText: getCorrectResourceText(
      checkoutType,
      r.homeAddressText,
      undefined
    ),
    contactDetailsText: getCorrectResourceText(
      checkoutType,
      r.contactDetailsText,
      undefined
    ),
    billingDataTitle: getCorrectResourceText(
      checkoutType,
      r.billingDataTitle,
      r.billingDataTitleOffer
    ),
    billingDataChoiceTitle: getCorrectResourceText(
      checkoutType,
      r.billingDataChoiceTitle,
      r.billingDataChoiceTitleOffer
    ),
    billingDataChoiceText: getCorrectResourceText(
      checkoutType,
      r.billingDataChoiceText,
      r.billingDataChoiceTextOffer
    ),
    billingDataForMeLabel: getCorrectResourceText(
      checkoutType,
      r.billingDataForMeLabel,
      r.billingDataForMeLabelOffer
    ),
    billingDataForCompanyLabel: getCorrectResourceText(
      checkoutType,
      r.billingDataForCompanyLabel,
      r.billingDataForCompanyLabelOffer
    ),
    billingDataCompanyText: getCorrectResourceText(
      checkoutType,
      r.billingDataCompanyText,
      r.billingDataCompanyTextOffer
    ),
    orderOverviewPersonalDetailsText: getCorrectResourceText(
      checkoutType,
      r.orderOverviewPersonalDetailsText,
      undefined
    ),
    consentText: getCorrectResourceText(checkoutType, r.consentText, undefined),
    orderOverviewModuleScheduleText: getCorrectResourceText(
      checkoutType,
      r.orderOverviewModuleScheduleText,
      undefined
    ),
    orderButtonText: getCorrectResourceText(
      checkoutType,
      r.orderButtonText,
      r.offerButtonText
    ),
    orderOverviewBillingDataTitle: getCorrectResourceText(
      checkoutType,
      r.orderOverviewBillingDataTitle,
      r.orderOverviewBillingDataTitleOffer
    ),
    orderOverviewBillingDataText: getCorrectResourceText(
      checkoutType,
      r.orderOverviewBillingDataText,
      r.orderOverviewBillingDataTextOffer
    ),
    orderOverviewBillingDataEditLinkText: getCorrectResourceText(
      checkoutType,
      r.orderOverviewBillingDataEditLinkText,
      r.orderOverviewBillingDataEditLinkTextOffer
    ),
    orderOverviewBillingDataEqualText: getCorrectResourceText(
      checkoutType,
      r.orderOverviewBillingDataEqualText,
      r.orderOverviewBillingDataEqualTextOffer
    ),
  };
}

export { getTextsMapping };
